/** Pole povolených znaků */
import { OWDataType } from "@multiweb/types/contracts";

/** Datové typy, které se mají formátovat jako BigNumber. */
export const BIG_NUMBER_DATA_TYPES: readonly (OWDataType | string)[] = [
    OWDataType.bcd,
    OWDataType.money,
    OWDataType.decimal,
    OWDataType.int64,
];

/** Klasická mezera */
export const CLASSIC_SPACE = " ";

/** Nedělitelná mezera (ASCII znak 160, &nbsp) */
export const NON_BREAKING_SPACE = "\u00a0";

/** Regulární výraz pro nalezení klasické mezery v řetězci */
export const CLASSIC_SPACE_REGEX = new RegExp(CLASSIC_SPACE, "g");

/** Znak pro minus, využívá se hlavně v arabštině. */
export const ARABIC_MINUS = String.fromCharCode(8722);

/**
 * Znak indikující, že řetězec v arabštině je zapsán ve směru RTL.
 * @see https://www.fontspace.com/unicode/char/061C-arabic-letter-mark
 */
export const ARABIC_LETTER_MARK = String.fromCharCode(1564);
